export const PYG = "pyg";
export const PYG_LABEL = "Guaraníes";
export const USD = "usd";
export const USD_LABEL = "Dólares Americanos";

export const CURRENCY_CHOICES: Map<string, string> = new Map([
  [PYG, PYG_LABEL],
  [USD, USD_LABEL],
]);
